module.exports = __webpack_public_path__ + "img/icon-more.1325e4e0.png";